import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    back: "",
  },
  mutations: {
    setBack(state, back) {
      state.back = back;
    }
  },
  actions: {
  },
  modules: {
  }
})
